const webURL = 'https://admin.reposit.co.uk';
const clientId = 'R2BLk9tXeL6jftv5XEgxxyHlBTAgGqh6';

export const appConfig = {
  links: {
    auth0: {
      logout: `https://reposit.eu.auth0.com/v2/logout?client_id=${clientId}`,
      login: `https://reposit.eu.auth0.com/authorize?response_type=token&client_id=${clientId}&redirect_uri=${webURL}/authenticate&audience=https://prod.api.com`,
    },
    local: {
      login: `${webURL}/login`,
    },
  },
  api: {
    basePath: 'https://api.reposit.co.uk',
  },
  earliestKpiDate: '2020-06-26',
  earliestReconciliationDate: '2023-01-01',
  hubspotPortalId: '5728567',
  inMaintenanceMode: false,
  newAdminUrl: 'https://admin-dashboard.reposit.co.uk',
  stripeDashboardUrl: 'https://dashboard.stripe.com/acct_17kJKXHPmZKAYYAo',
};
